import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { apiProductsList } from "api/productApi";
import { getQueryParam, setQueryParam } from "helpers/queryParam";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { useAppDispatch, useAppSelector } from "store/store";

export default function TableSelectInvoice({ refetch }: { refetch: (args: any) => void }) {
  const dispatch = useAppDispatch();
  const store = useAppSelector((x: any) => x);
  const fromDate = store.appReducer.fromDate;
  const toDate = store.appReducer.toDate;
  const paginationState = store.paginationReducer
  const { token } = store.businessReducer.business;
  const products: Product[] = store?.productReducer?.allProducts || [];
  const onChange = (val?: any) => {
    if (val) {
      const options = {
        "subColumn": "date",
        "searchText": fromDate,
        "searchTextAlt": toDate,
      }

      setQueryParam("productId", val);
      dispatch(refetch({ pagination: paginationState, token, search: options, id: val }));
    }
  };

  return (
    <Box
      sx={{
        minWidth: 120,
        maxWidth: 330,
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <FormControl fullWidth sx={{ maxWidth: 300 }}>
        <BasicSelect
          style={{ minWidth: 245 }}
          options={products}
          onChange={onChange}
          placeholder="محصول"
          defaultValue={getQueryParam("productId")}
          withSearch
          withRefresh
          refreshList={() => dispatch(apiProductsList({ token }))}
        />
      </FormControl>
    </Box>
  );
}
